<ng-container *ngrxLet="hasMarkers$ as hasMarkers">
    <div class="flex-row">
        <button
            (click)="downloadMarkers()"
            [disabled]="!hasMarkers"
            class="icon-button"
            [attr.aria-label]="'Download markers'"
            [title]="
                hasMarkers
                    ? 'Download selected intensity maps as CSV files'
                    : 'No data available for download'
            "
        >
            <cds-icon shape="download"></cds-icon>
        </button>
        <clr-combobox-container>
            <label>X-Axis</label>
            <clr-combobox
                #xAxisCombo
                name="x-axis-marker-selection"
                [ngModel]="markerXName$ | async"
                (ngModelChange)="setDataXAxis($event)"
                (clrInputChange)="onXAxisSearch($event)"
                (clrOpenChange)="onXAxisOpenChange($event)"
                [disabled]="!hasMarkers"
            >
                <clr-options>
                    <ng-container *ngrxLet="filteredXMarkers$ as xMarkers">
                        <clr-option
                            *ngFor="let marker of xMarkers.options"
                            [clrValue]="marker.name"
                            [title]="marker.name"
                        >
                            <span class="marker-option-label">{{ marker.name }}</span>
                        </clr-option>
                        <div *ngIf="xMarkers.hasMore" class="more-results-hint">…</div>
                    </ng-container>
                </clr-options>
            </clr-combobox>
        </clr-combobox-container>
        <clr-combobox-container>
            <label>Y-Axis</label>
            <clr-combobox
                #yAxisCombo
                name="y-axis-marker-selection"
                [ngModel]="markerYName$ | async"
                (ngModelChange)="setDataYAxis($event)"
                (clrInputChange)="onYAxisSearch($event)"
                (clrOpenChange)="onYAxisOpenChange($event)"
                [disabled]="!hasMarkers"
            >
                <clr-options>
                    <ng-container *ngrxLet="filteredYMarkers$ as yMarkers">
                        <clr-option
                            *ngFor="let marker of yMarkers.options"
                            [clrValue]="marker.name"
                            [title]="marker.name"
                        >
                            <span class="marker-option-label">{{ marker.name }}</span>
                        </clr-option>
                        <div *ngIf="yMarkers.hasMore" class="more-results-hint">…</div>
                    </ng-container>
                </clr-options>
            </clr-combobox>
        </clr-combobox-container>
        <clr-combobox-container>
            <label>Color-Axis</label>
            <clr-combobox
                #colorAxisCombo
                name="color-axis-marker-selection"
                [ngModel]="markerColorName$ | async"
                (ngModelChange)="setDataColorAxis($event)"
                (clrInputChange)="onColorAxisSearch($event)"
                (clrOpenChange)="onColorAxisOpenChange($event)"
                [disabled]="!hasMarkers"
            >
                <clr-options>
                    <ng-container *ngrxLet="filteredColorMarkers$ as colorMarkers">
                        <clr-option
                            *ngFor="let marker of colorMarkers.options"
                            [clrValue]="marker.name"
                            [title]="marker.name"
                        >
                            <span class="marker-option-label">{{ marker.name }}</span>
                        </clr-option>
                        <div *ngIf="colorMarkers.hasMore" class="more-results-hint">…</div>
                    </ng-container>
                </clr-options>
            </clr-combobox>
        </clr-combobox-container>
    </div>
    <cds-tree>
        <ng-template #recursiveSelectionTree let-nodes>
            <ng-container *ngFor="let node of nodes">
                <cds-tree-item
                    [expanded]="node.show"
                    [expandable]="hasChildren(node)"
                    (expandedChange)="toggleNode(node)"
                    [disabled]="(colorAxisActive$ | async) ?? false"
                >
                    <ng-container *ngIf="!node.isTopLevel; else topLevelLabel">
                        <cds-checkbox>
                            <label [innerHTML]="getSelectionLabel(node)"></label>
                            <input
                                type="checkbox"
                                [ngModel]="node.selected"
                                (ngModelChange)="selectSelection(node)"
                                [disabled]="(colorAxisActive$ | async) ?? false"
                            />
                        </cds-checkbox>
                    </ng-container>
                    <ng-template #topLevelLabel>
                        <label [innerHTML]="node.id"></label>
                    </ng-template>
                    <ng-container *ngIf="node.show && hasChildren(node)">
                        <ng-container
                            *ngTemplateOutlet="
                                recursiveSelectionTree;
                                context: { $implicit: node.nodes }
                            "
                        >
                        </ng-container>
                    </ng-container>
                </cds-tree-item>
            </ng-container>
        </ng-template>
        <ng-container *ngIf="selectionType > 0">
            <ng-container
                *ngTemplateOutlet="recursiveSelectionTree; context: { $implicit: selectionNodes }"
            >
            </ng-container
        ></ng-container>
    </cds-tree>
</ng-container>
